
import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Create, FileCopySharp, Visibility } from '@material-ui/icons';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { Link, useParams } from 'react-router-dom';
import Badge from 'components/Badge/Badge';

//servicios
import { wsGet, wsUpdate, wsFindBy } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import Button from 'components/CustomButtons/Button.js';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 180 },
  { Header: 'Tipo', accessor: 'type', width: 140},
  { Header: 'Actividad', accessor: 'activity_description', width: 200},
  { Header: 'Ruta Archivo', accessor: 'file_route'},
  { Header: 'Nombre Archivo', accessor: 'file_name'},
  { Header: 'Estado', accessor: 'state', width: 120 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];
const permission = {
  store: 'REPORT_WHATSAPP_STORE',
  update: 'REPORT_WHATSAPP_UPDATE',
  show: 'REPORT_WHATSAPP_SHOW',
  delete: 'REPORT_WHATSAPP_DESTROY',
};
export default WithApp(function Colgate(props) {
  const { id } = useParams();
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [dataLoading, setDataLoading] = useState(false);
  const [cuotasDetail, setCuotasDetail] = useState([]);


  async function listCuotaDetail() {
    setDataLoading(true);
    let response = await wsGet('report/file-report');
    setDataLoading(false);
    if (response.success) setCuotasDetail(response.data);
  }

  useEffect(() => {
    listCuotaDetail();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={listCuotaDetail}
          id={id}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard permission={ConstantPermissions[permission.store]}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de archivos para el reporte
            {dataLoading && <LoadingSpinner />}
            </h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="archivos_reporte"
              formatDate="DD-MM-YYYY HH:mm"
              columns={columns}
              data={cuotasDetail.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions[permission.update]}>
                        <Button justIcon round simple color="warning" onClick={() => setOpen(item)}>
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions[permission.show]}>
                        <Button justIcon round simple color={props.themeContext.buttonColorWarning}>
                          <Link to={`${item.id}`}>
                            <Visibility />
                          </Link>
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions[permission.delete]}>
                        <ButtonDelete
                          entity="report/file-report"
                          id={item.id}
                          reload={() => {
                            setDataLoading(true);
                            listCuotaDetail().then(() => setDataLoading(false));
                        }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  file_route: item.file_route,
                  file_name: item.file_name,
                  activity_description: item.activity?.description,
                  type: item.type === 'xlsx' ? 'Imagen' : item.type === 'arch' ? 'Archivo' : item.type === 'rps' ? 'Reporte Supervisor' : item.type,
                  state: item.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
